import { Directive, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[tabHeading]'
})
export class TabHeadingDirective {
  viewContainerRef: ViewContainerRef;
  templateRef: TemplateRef<any>;

  constructor(
    templateRef: TemplateRef<any>,
    viewContainerRef: ViewContainerRef
  ) {
    this.templateRef = templateRef;
    this.viewContainerRef = viewContainerRef;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/achoo-tabs/tab-heading.directive.ts